import { supabase } from '@/supabase';

/**
 * Aufruf einer URL mit Supabase-JWT + anon-Key im Header.
 * @param {string} url
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export const fetchWithAuth = async (url, init = {}) => {
  // Aktuelle Session abholen
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers = {
    ...init.headers,
    // Vue-CLI liest ENV-Variablen aus process.env
    apikey: process.env.VUE_APP_SUPABASE_ANON_KEY,
    Authorization: `Bearer ${session?.access_token ?? ''}`,
  };

  return fetch(url, { ...init, headers });
};
